import React from "react";
import { useEffect, useState } from "react";
import {  EditTiming, getTiming } from "../../../services/adminServices";
import toast from "react-hot-toast";
const Timing = () => {
  const [list, setList] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getTiming();
        console.log(data.result[0]);
        setList(data.result[0]);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const EditTime = async () => {
    try {
      const timeForRequest = document.getElementById("timeForRequest").value;
      const timeForUpdate = document.getElementById("timeForUpdate").value;
      if (timeForRequest && timeForUpdate) {
        const sendData = {
          timeForRequest ,
          timeForUpdate ,
           id : list.id
        }
        const { data } = await EditTiming(sendData);
        toast.success("زمانبندی با موفقیت ویرایش شد");
        console.log(data);
      } else {
        toast.error("مقادیر نمی تواند خالی باشد");
      }
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  return (
    <div>
    {list.timeForRequest && (
      <div className="row align-items-center text-end">
        <div className="col-lg-9 mb-4">
          <label>حداقل زمان جهت بروزرسانی صورت کارشناسی براساس ماه </label>
          <input
            id="timeForUpdate"
            defaultValue={list.timeForUpdate}
            className="admin-setting-input"
          />
        </div>
        <div className="col-lg-9 mb-4">
          <label>
            حداقل زمان جهت درخواست مجدد روی یک صورت کارشناسی صورت کارشناسی
            براساس ماه
          </label>
          <input
            id="timeForRequest"
            defaultValue={list.timeForRequest}
            className="admin-setting-input"
          />
        </div>
        <div className="col-10">
          <button
            className="btn ms-3"
            style={{
              width: "100px",
              backgroundColor: "#EF971C",
              borderRadius: "20px",
            }}
            onClick={()=>{EditTime()}}
          >
            ویرایش
          </button>
        </div>
      </div>
    )}
    </div>
  );
};

export default Timing;
